export default class FileUploadDoesNotExistError extends Error {}
